import { render, staticRenderFns } from "./WelcomePageDesigner.vue?vue&type=template&id=b11aa844&scoped=true"
import script from "./WelcomePageDesigner.vue?vue&type=script&lang=js"
export * from "./WelcomePageDesigner.vue?vue&type=script&lang=js"
import style0 from "./WelcomePageDesigner.vue?vue&type=style&index=0&id=b11aa844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11aa844",
  null
  
)

export default component.exports